const customEventName = "appshellNavigate";

const subscribe = (basename: string, callback: (path: string) => void) => {
  const routingHandler = (evt: CustomEvent) => {
    const pathname = evt.detail.href;

    if (pathname.startsWith(basename)) {
      evt.preventDefault();
      /* eslint-disable callback-return */
      callback(pathname.replace(basename, ""));
    }
  };

  window.addEventListener(customEventName, routingHandler as EventListener);

  return () => {
    window.removeEventListener(customEventName, routingHandler as EventListener);
  };
};

const emit = (href) => {
  const event = new CustomEvent(customEventName, {
    cancelable: true,
    detail: {
      href,
    },
  });

  // Returns true unless a listener calls e.preventDefault().
  return window.dispatchEvent(event);
};

export { emit, subscribe };
